import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import Image from '../../elements/Image';
import { useLanguage } from '../../../contexts/LanguageContext';

const Banner = ({ ...props }) => {
  // The banner is always shown; keep it as state so it can be made dismissible later.
  const [bannerOpen] = useState(true);
  const { lang } = useLanguage();

  const webWaUrl =
    lang === 'es'
      ? 'https://web.whatsapp.com/send?phone=19544708414&text=Hola,%20quiero%20conocer%20m%C3%A1s%20sobre%20e-comienza.'
      : 'https://web.whatsapp.com/send?phone=19544708414&text=Hello,%20I%20want%20to%20learn%20more%20about%20e-comienza.';
  const mobileWaUrl =
    lang === 'es'
      ? 'whatsapp://send?phone=19544708414&text=Hola,%20quiero%20conocer%20m%C3%A1s%20sobre%20e-comienza.'
      : 'whatsapp://send?phone=19544708414&text=Hello,%20I%20want%20to%20learn%20more%20about%20e-comienza.';

  const label = lang === 'es' ? 'Escríbenos' : 'Chat with Us';
  const ariaLabel = lang === 'es' ? 'Escríbenos por WhatsApp' : 'Chat with us on WhatsApp';

  function goToWhatsapp() {
    if (isMobile) {
      window.open(mobileWaUrl, '_blank');
    } else {
      window.open(webWaUrl, '_blank');
    }
  }

  return (
    <>
      {bannerOpen && (
        <div {...props} className="banner">
          <div
            className="banner-inner text-xxs"
            onClick={() => goToWhatsapp()}
            onKeyPress={(e) => (e.key === 'Enter' || e.key === ' ') && goToWhatsapp()}
            role="button"
            tabIndex={0}
            aria-label={ariaLabel}
          >
            {/* Decorative: the control is already labelled by its text and aria-label. */}
            <Image
              src={require('../../../assets/images/wa-logo.wine.svg')}
              alt=""
              width={50}
              height={50}
            />
            <div className="banner-container">
              {/* Not an <a>: the whole banner is the control, an href-less anchor is not focusable. */}
              <span className="banner-link banner-link-white">{label}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Banner;
